// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Звернення громадян» (Citizen appeals, ключ `appeal`, група `constituents`). */
export const citizenAppealsManifest: IModuleManifest = {
  key: 'appeal',
  group: 'constituents',
  slug: 'citizen-appeals',
  prefix: 'APL',
  name: { en: 'Citizen appeals', uk: 'Звернення громадян' },
  entities: [
    { key: 'appeal', slug: 'appeal', name: { en: 'Citizen appeals', uk: 'Звернення громадян' }, main: true },
    { key: 'appeal_citizen', slug: 'appeal-citizen', name: { en: 'Appeal Citizens', uk: 'Громадяни' }, main: false },
    { key: 'appeal_answer', slug: 'appeal-answer', name: { en: 'Appeal Answers', uk: 'Відповіді' }, main: false },
    { key: 'appeal_document', slug: 'appeal-document', name: { en: 'Appeal Documents', uk: 'Документи' }, main: false },
    { key: 'appeal_deadline', slug: 'appeal-deadline', name: { en: 'Appeal Deadlines', uk: 'Строки' }, main: false },
    { key: 'appeal_topic', slug: 'appeal-topic', name: { en: 'Appeal Topics', uk: 'Теми' }, main: false },
    { key: 'appeal_status', slug: 'appeal-status', name: { en: 'Appeal Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/citizenAppealsSlice').then((m) => m.citizenAppealsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
